import _ from "lodash";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import AssignedList from "@/Components/common/client/timesheet/AssignedList";
import TimesheetTypes from "@/Components/common/client/timesheet/TimesheetTypes";
import { updateactivePages } from "@/reducers/clientcommon";
import {
  deSelectAllTimesheets,
  fetchAssignedTimesheets,
  setAssignedTimesheetsLoading,
  updateFilters,
  updatePagination,
} from "@/reducers/timesheets/timesheetassigned";
import { fetchTimesheetCount } from "@/reducers/timesheets/timesheets";
import useTitle from "@/utilities/hooks/useTitle";

const Assigned = () => {
  useTitle("Assigned Timesheets");
  const { pagination } = useSelector((state) => state.timesheetAssigned);
  const dispatch = useDispatch();
  const location = useLocation();
  useEffect(() => {
    const { state } = location;
    let filterObj = {};
    if (!_.isEmpty(state)) {
      filterObj = { ...filterObj, ...state };
      dispatch(updateFilters(filterObj));
    }
    dispatch(fetchTimesheetCount());
    dispatch(
      updatePagination({
        ...pagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(setAssignedTimesheetsLoading(true));
    dispatch(deSelectAllTimesheets());
    dispatch(fetchAssignedTimesheets());
    dispatch(
      updateactivePages({
        activePage: "timesheets",
        activeSubPage: "assigned",
        callback: () => {
          if (!_.isEmpty(filterObj)) {
            dispatch(updateFilters(filterObj));
          }
        },
      }),
    );
  }, []);
  return (
    <div className="flex flex-col gap-4">
      <TimesheetTypes />
      <AssignedList />
    </div>
  );
};

export default Assigned;
